export {default} from "./behavioralContext.js";
